import React, { useContext, useEffect } from 'react';
import {
  MOBILE_WIDTH,
  HEADER_HEIGHT,
  FOOTER_HEIGHT,
} from '../../constants/dims';
import styled from 'styled-components/macro';
import Header from './Header';
import GetStartedNow from './GetStartedNow';
import HowKidsImprove from './HowKidsImprove';
import StressFree from './StressFree';
import ResearchSection from './Research';
import Collaborate from './Collaborate';
import Potential from './Potential';
import Footer from './Footer';
import { Switch, Route, Redirect } from 'react-router-dom';
import TOS from '../termsOfService/TermsOfService';
import routes from '../../constants/routes';
import PrivacyPolicy from '../privacyPolicy/PrivacyPolicy';
import About from '../about/About';
import Team from '../team/Team.jsx';
import Contact from '../contact/Contact';
import GetStarted from '../getStarted/GetStarted';
import Research from '../research/Research';
import Help from '../help/Help';
import PreferencesContext from '../../contexts/preferences';
import Shop from '../shop/Shop';
import PaymentSuccess from '../paymentSuccess/PaymentSuccess';
import PaymentCanceled from '../paymentCanceled/PaymentCanceled';

export const Container = styled.div`
  width: 100%;
  position: relative;
`;

export const Canvas = styled.div`
  top: ${HEADER_HEIGHT}px;
  position: relative;
  min-height: calc(100vh - ${HEADER_HEIGHT}px - ${FOOTER_HEIGHT}px);
  box-sizing: border-box;

  @media screen and (max-width: ${MOBILE_WIDTH}px) {
    top: auto;
    min-height: fit-content;
  }
`;

export const Content = () => {
  const { inGame } = useContext(PreferencesContext);

  useEffect(() => {
    document.title = 'Brainquake';
  }, []);

  return (
    <React.Fragment>
      {!inGame && (
        <React.Fragment>
          <GetStartedNow scrollTo="#improve" />
          <HowKidsImprove />
        </React.Fragment>
      )}

      {inGame && (
        <React.Fragment>
          <HowKidsImprove />
          <GetStartedNow />
        </React.Fragment>
      )}

      <StressFree />
      <ResearchSection />
      <Collaborate />
      <Potential />
    </React.Fragment>
  );
};

const Landing = () => {
  return (
    <Container>
      <Header />
      <Canvas>
        <Switch>
          <Route exact path="/" component={Content} />
          <Route path={routes.tos} component={TOS} />
          <Route path={routes.privacyPolicy} component={PrivacyPolicy} />
          <Route path={routes.about} component={About} />
          <Route path={routes.team} component={Team} />
          <Route path={routes.contact} component={Contact} />
          <Route path={routes.getStarted} component={GetStarted} />
          <Route path={routes.research} component={Research} />
          <Route path={routes.help} component={Help} />
          <Route path={routes.shop} component={Shop} />
          <Route path={routes.paymentSuccess} component={PaymentSuccess} />
          <Route path={routes.paymentCanceled} component={PaymentCanceled} />
          <Redirect to="/" />
        </Switch>
      </Canvas>
      <Footer />
    </Container>
  );
};

export default Landing;
